import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {AuthGuardService} from './services/auth-guard.service';

const routes: Routes = [
  
  {
    path : '',
    redirectTo : 'admin',
    pathMatch : 'full'
  },
  {
    path: 'user',
    loadChildren: () => import('./pages/tabs-user/tabs-user.module').then( m => m.TabsUserPageModule)
  },
  {
    path: 'admin-login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./pages/menu/menu.module').then( m => m.MenuPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'account',
    loadChildren: () => import('./pages/account/account.module').then( a => a.AccountPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'extras',
    loadChildren: () => import('./pages/extras/extras.module').then( m => m.ExtrasPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'extras-modal',
    loadChildren: () => import('./pages/extras-modal/extras-modal.module').then( m => m.ExtrasModalPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'item',
    loadChildren: () => import('./pages/item/item.module').then( m => m.ItemPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'item-modal',
    loadChildren: () => import('./pages/item-modal/item-modal.module').then( m => m.ItemModalPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'order',
    loadChildren: () => import('./pages/order/order.module').then( m => m.OrderPageModule)
  },
  {
    path: 'recent',
    loadChildren: () => import('./pages/recent/recent.module').then( m => m.RecentPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'favorites',
    loadChildren: () => import('./pages/favorites/favorites.module').then( m => m.FavoritesPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'modal-location',
    loadChildren: () => import('./modals/location/modal-location/modal-location.module').then( m => m.ModalLocationPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'modal-color',
    loadChildren: () => import('./modals/theme/modal-color/modal-color.module').then( m => m.ModalColorPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'modal-login-secure',
    loadChildren: () => import('./modals/login-secure/modal-login-secure/modal-login-secure.module').then( m => m.ModalLoginSecurePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'finish-order',
    loadChildren: () => import('./modals/finish-order/finish-order.module').then( m => m.FinishOrderPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'detail-order',
    loadChildren: () => import('./modals/detail-order/detail-order.module').then( m => m.DetailOrderPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'edit-order',
    loadChildren: () => import('./modals/edit-order/edit-order.module').then( m => m.EditOrderPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'forget-password',
    loadChildren: () => import('./pages/forget-password/forget-password.module').then( m => m.ForgetPasswordPageModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./pages/reset-password/reset-password.module').then( m => m.ResetPasswordPageModule)
  },
  {
    path: 'order/credit-payment',
    loadChildren: () => import('./pages/credit-payment/credit-payment.module').then( m => m.CreditPaymentPageModule)
  },
  {
    path: 'card-payment',
    loadChildren: () => import('./modals/card-payment/card-payment.module').then( m => m.CardPaymentPageModule)
  },
  {
    path: 'active-order',
    loadChildren: () => import('./pages/active-order/active-order.module').then( m => m.ActiveOrderPageModule)
  },
  {
    path: 'tabs-user',
    loadChildren: () => import('./pages/tabs-user/tabs-user.module').then( m => m.TabsUserPageModule)
  },
  {
    path: 'home-user',
    loadChildren: () => import('./pages/home-user/home-user.module').then( m => m.HomeUserPageModule)
  },  {
    path: 'tipping-custom',
    loadChildren: () => import('./modals/tipping-custom/tipping-custom.module').then( m => m.TippingCustomPageModule)
  },
  {
    path: 'select-location',
    loadChildren: () => import('./modals/select-location/select-location.module').then( m => m.SelectLocationPageModule)
  },


];

@NgModule({
  imports: [
   RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules , useHash: true}) //despliege web
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
